import React from "react";
import Link from "next/link";

export function Footer() {
  return (
    <footer className="w-full bg-paper-deep border-t border-line mt-auto py-12 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start justify-between gap-8">
        <div>
          <span className="font-serif text-2xl font-bold tracking-tight text-ink">
            Curated Den
          </span>
          <p className="text-xs text-ink-soft max-w-sm leading-relaxed mt-2">
            AI interior design that specifies real, buyable products. We preserve your architecture and match pieces to your budget.
          </p>
        </div>

        <div className="flex gap-12 sm:gap-24">
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-wider text-ink">Design</h4>
            <ul className="space-y-2.5 text-sm text-ink-soft">
              <li>
                <Link href="/design" className="hover:text-ink transition-colors">Start Redesign</Link>
              </li>
              <li>
                <a href="/#styles" className="hover:text-ink transition-colors">Sample Rooms</a>
              </li>
              <li>
                <span className="text-ink-soft/50 cursor-not-allowed">Book Consult (Soon)</span>
              </li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-wider text-ink">Legal</h4>
            <ul className="space-y-2.5 text-sm text-ink-soft">
              <li>
                <Link href="/privacy" className="hover:text-ink transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <a href="#" className="hover:text-ink transition-colors">Terms of Service</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="max-w-6xl mx-auto border-t border-line mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-ink-soft gap-4">
        <span>© {new Date().getFullYear()} Curated Den Ltd. All rights reserved.</span>
        <span>Built with Next.js 15 & Supabase</span>
      </div>
    </footer>
  );
}
